/**
 * Largest attachment the composer accepts.
 *
 * Mirrored server-side by `CONVERSATION_FILE_SIZE_LIMIT_BYTES` in
 * `api/src/common/constants/conversation-file.ts`. The two cannot share one
 * declaration: `@shaarp/common` only re-exports types, and importing a runtime
 * value from it crashes the API at boot. Change one, change the other.
 */
export const FILES_UPLOAD_SIZE_LIMIT_BYTES = 20 * 1024 * 1024;

/** The same limit, written the way it is shown to the user. */
export const FILES_UPLOAD_SIZE_LIMIT_LABEL = `${
  FILES_UPLOAD_SIZE_LIMIT_BYTES / (1024 * 1024)
} Mo`;
